import styled from 'styled-components'

export const Container = styled.div`
  display: grid;
  gap: 16px;
`

export const Card = styled.div`
  background-color: ${({ theme }) => theme.cor40}!important;
  padding: 16px;
  border-radius: 8px;
  display: grid;
  gap: 24px;
`

export const FieldsWrapper = styled.div`
  display: grid;
  gap: 8px;
`

export const Label = styled.label`
  font-weight: 400;
  font-size: 20px;
  letter-spacing: 0.15px;
  color: ${({ theme }) => theme.cor9};
  margin: 0;
`

export const ItemFiltro = styled.div`
  display: grid;
  gap: 24px;
`

export const RadioWrapper = styled.div`
  display: flex;
  gap: 16px;
`

export const SpanDimmed = styled.span`
  color: ${({ theme }) => theme.designSystem.text.dimmed};
`
